import type { TextNodeType } from "../../../FormattedText/FormattedText";
import FormattedText from "../../../FormattedText/FormattedText";
import type { MyCashState } from "../../ListingPageV2.types";
import { Cta, Icon, InfoIcon, Row, TextCol, Wrap } from "./Styles";

function InfoOutlineSvg() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
        fill="#757575"
      />
    </svg>
  );
}

interface MyCashDataState {
  icon?: string;
  ctaText?: string;
  title?: TextNodeType;
}

interface MyCashPersuasionProps {
  myCashData?: {
    unApplied?: MyCashDataState;
    loggedOut?: MyCashDataState;
    applied?: MyCashDataState;
  };
  myCashState?: MyCashState;
  onMyCashPress?: () => void;
}

export const MyCashPersuasion = ({
  myCashData,
  myCashState = "unApplied",
  onMyCashPress,
}: MyCashPersuasionProps) => {
  const current = myCashData?.[myCashState];
  if (!current) return null;

  return (
    <Wrap>
      <Row $applied={myCashState === "applied"}>
        {current.icon ? <Icon src={current.icon} alt="" /> : null}
        <TextCol>
          <FormattedText value={current.title} />
        </TextCol>
        <Cta type="button" onClick={onMyCashPress} aria-label="Info">
          {current.ctaText ? (
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 14,
                fontWeight: 700,
                color: "#008cff",
                whiteSpace: "nowrap",
              }}
            >
              {current.ctaText}
            </span>
          ) : (
            <InfoIcon>
              <InfoOutlineSvg />
            </InfoIcon>
          )}
        </Cta>
      </Row>
    </Wrap>
  );
};
